import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Flex, Form, List, Select, } from "antd";
import FloatingModal from "../../../../components/common/FloatingModal";
import { InnerFormSection } from "../../editor.style";
import Icon from "../../../../components/common/Icon";
import { useRef, useState } from "react";
const RelatedGroups = ({ form, value, onChange, options }) => {
    const [modalForm] = Form.useForm();
    const data = Form.useWatch("locationStates", form);
    const [isModalVisible, setModalVisible] = useState(false);
    const handleAddLocationState = () => {
        const data = { label: "", siblings: [] };
        setModalVisible(data);
        modalForm.setFieldsValue(data);
    };
    const handleCloseModal = () => {
        setModalVisible(false);
    };
    const refDiv = useRef(null);
    // Function to convert an array of moment objects to a date range string
    const convertMomentsToDateRangeString = ([startMoment, endMoment]) => `${startMoment.format("DD-MM-YYYY")} - ${endMoment.format("DD-MM-YYYY")}`;
    return (_jsxs(_Fragment, { children: [_jsxs(InnerFormSection, { ref: refDiv, children: [_jsx(List, { children: (value || []).map((it, index) => {
                            return (_jsxs(List.Item, { children: [_jsx(List.Item.Meta, { title: it.label, description: (it?.siblings || []).join(", ") }), _jsx(Button, { variant: "text", size: "small", color: "default", icon: _jsx(Icon, { icon: "edit-02", size: 15 }), onClick: () => {
                                            setModalVisible({ ...it, index });
                                            modalForm.setFieldsValue(it);
                                        } }), _jsx(Button, { variant: "text", size: "small", color: "danger", icon: _jsx(Icon, { icon: "trash-01", size: 15 }), onClick: () => {
                                            const previousValue = [...(value || [])];
                                            if (previousValue.length === 1)
                                                onChange?.([]);
                                            else {
                                                previousValue.splice(index, 1);
                                                onChange?.(previousValue);
                                            }
                                        } })] }, index + it.label));
                        }) }), _jsx(Button, { variant: "dashed", color: "default", block: true, icon: _jsx(Icon, { icon: "link-03", size: 15 }), iconPosition: "end", onClick: handleAddLocationState, children: "Add Related Group" })] }), _jsxs(FloatingModal, { referenceDiv: refDiv, isVisible: !!isModalVisible, width: 320, onClose: handleCloseModal, children: [_jsxs(Form, { form: modalForm, layout: "vertical", onFinish: (values) => {
                            let previousValue = [...(value || [])];
                            if (typeof isModalVisible === "object" &&
                                isModalVisible.index !== undefined) {
                                previousValue = previousValue.map((it, index) => {
                                    if (index === isModalVisible.index) {
                                        return values;
                                    }
                                    return it;
                                });
                            }
                            else {
                                previousValue.push(values);
                            }
                            onChange?.(previousValue);
                            setTimeout(() => {
                                setModalVisible(false);
                            }, 100);
                        }, children: [_jsx(Form.Item, { tooltip: "Label", name: "label", style: { marginBottom: "8px" }, children: _jsx(Select, { placeholder: "Select Label", variant: "filled", options: [
                                        { label: "Reference Point", value: "REFERENCE_POINT" },
                                        { label: "Curbside Pickup", value: "CURBSIDE_PICKUP" },
                                    ] }) }), _jsx(Form.Item, { tooltip: "Siblings", name: "siblings", style: { marginBottom: "8px" }, children: _jsx(Select, { mode: "tags", placeholder: "Select Related Locations", variant: "filled", options: options }) })] }), _jsxs(Flex, { justify: "flex-end", gap: 10, children: [_jsx(Button, { variant: "dashed", color: "default", onClick: handleCloseModal, children: "Close" }), _jsx(Button, { onClick: () => {
                                    modalForm.submit();
                                }, color: "primary", variant: "solid", children: typeof isModalVisible === "object"
                                    ? isModalVisible.index !== undefined
                                        ? "Update"
                                        : "Add"
                                    : "Add" })] })] })] }));
};
export default RelatedGroups;
